import React, { useEffect } from 'react';
import { router } from 'expo-router';
import useStore from '@/stores/useStore';
import VideoFeed from '@/shared/components/video/VideoFeed';
import { FullScreenLoader } from '@/shared/components/FullScreenLoader';
import { ROUTES } from '@/shared/constants/routes';

const VideoSession = () => {
  const { activeSessionName } = useStore();

  // Redirect if no active session
  useEffect(() => {
    if (!activeSessionName) {
      router.replace(ROUTES.SESSIONS.path);
    }
  }, [activeSessionName]);

  // Show loader while session is being established
  if (!activeSessionName) {
    return <FullScreenLoader />;
  }

  return <VideoFeed />;
};

export default VideoSession;
